/**
 * Fixed flavor values that are always valid.
 */
export const FLAVORS = {
  NO_SEARCH: 'nosearch',
  MIN_NAV: 'minnav',
  CTRL: 'ctrl',
  PROXIMITY: 'proximity',
};

/**
 * String constants for flavor group names, for use with flavorStore.findByGroup / hasGroup.
 */
export const FLAVOR_GROUP_NAMES = {
  TARGET_GROUP: 'TARGET_GROUP',
  CANOPY: 'CANOPY',
  SESSION: 'SESSION',
};

/**
 * Inventory filters that may be persisted for the current session.
 */
export const SESSION_FLAVOR_FILTERS = {
  DTG: 'dtg',
  DRV: 'drv',
  REACH: 'reach',
};

/**
 * Maximum lengths for values persisted by session inventory filters.
 */
export const SESSION_INVENTORY_FILTER_MAX_LENGTHS = {
  [SESSION_FLAVOR_FILTERS.DTG]: 64,
  [SESSION_FLAVOR_FILTERS.DRV]: 20,
  [SESSION_FLAVOR_FILTERS.REACH]: 4,
};

/**
 * Flavor groups — maps group name to a regex that matches valid tokens in that group.
 */
export const FLAVOR_GROUPS = {
  [FLAVOR_GROUP_NAMES.TARGET_GROUP]: /^tg_[\w-]+$/,
  [FLAVOR_GROUP_NAMES.CANOPY]: /^canopy[\w-]*$/,
  [FLAVOR_GROUP_NAMES.SESSION]: /^ses:(?:dtg|drv|reach)$/,
  // Future groups can be added here, e.g.:
  // [FLAVOR_GROUP_NAMES.CAMPAIGN]: /^cmp_[\w-]+$/,
};

/**
 * Maximum length of the flavor cookie value.
 * Tokens are trimmed from the end to fit within this limit.
 */
export const FLAVOR_MAX_LENGTH = 150;
